import { Window } from './shared/akatypes';

declare const window: Window;

const jQuery = window.jQuery;

// bracket blinking
function bracketOn() {
  jQuery('#moveToContent').addClass('active');
}

function bracketOff() {
  jQuery('#moveToContent').removeClass('active');
}

function bracketBlink() {
  bracketOn();
  setTimeout(bracketOff, 150);
  setTimeout(bracketOn, 300);
  setTimeout(bracketOff, 450);
}

function startBlink() {
  window.intId = setInterval(bracketBlink, 2000);
}

function cancelBlink(id: any) {
  jQuery('#moveToContent').removeClass('active');
  clearInterval(id);
}

export function bindBlink() {
  jQuery(document).ready(function () {
    window.document
      .getElementById('moveToContent')
      .addEventListener('mouseover', () => {
        cancelBlink(window.intId);
        jQuery('#moveToContent').addClass('active');
      });
    window.document
      .getElementById('moveToContent')
      .addEventListener('mouseout', () => {
        jQuery('#moveToContent').removeClass('active');
        startBlink();
      });

    startBlink();
  });
}

export function bindSaveInterestBlock() {
  jQuery(document).ready(function () {
    console.log('bindSaveInterestBlock1');
    setTimeout(() => {
      console.log('bindSaveInterestBlock2');
      jQuery('#saveinterestheader').click(function () {
        console.log('saveinterestheader CLICK');
        jQuery('#saveinterestblock').toggleClass('u-hide');
      });
    }, 100);
  });
}
